<ng-container *ngIf="announcement">
  <div class="edited">
    <h1 class="edited-label">
      {{
        isEdited
          ? ('label.EditedAnnouncement' | translate)
          : ('label.CurrentAnnouncement' | translate)
      }}
    </h1>
    <div class="edited-announcement">
      <div
        class="announcement-type"
        [class.changed-label]="isChanged(entityAttributes.Type)"
      >
        <span style="font-weight: 600"
          >{{ 'label.AnnouncementType' | translate }}:</span
        >
        <span>{{ announcement.announcementTypeName }}</span>
      </div>
      <div class="position-name">
        <span
          [class.changed-label]="isChanged(entityAttributes.Title)"
          style="font-weight: 600"
          >{{ 'label.VacantPositionTitle' | translate }}
        </span>
        <span class="vacant-position-title">{{ announcement.title }}</span>
      </div>
      <div class="position-name" *ngIf="announcement.anonymousCustomerName">
        <span
          [class.changed-label]="isChanged(entityAttributes.CustomerName)"
          style="font-weight: 600"
          >{{ 'label.AnonymousName' | translate }}
        </span>
        <span class="vacant-position-title">{{
          announcement.anonymousCustomerName
        }}</span>
      </div>

      <div class="position-name" *ngIf="announcement.anonymousCustomerName2">
        <span
          [class.changed-label]="isChanged(entityAttributes.CustomerName2)"
          style="font-weight: 600"
          >{{ 'label.AnonymousNameEng' | translate }}
        </span>
        <span class="vacant-position-title">{{
          announcement.anonymousCustomerName2
        }}</span>
      </div>

      <div class="position-name" *ngIf="announcement.title2">
        <span
          [class.changed-label]="isChanged(entityAttributes.Title2)"
          style="font-weight: 600"
          >{{ 'label.VacantPositionTitle' | translate }}
          {{ alternativeLanguage }}
        </span>
        <span class="vacant-position-title">{{ announcement.title2 }} </span>
      </div>

      <!-- announcement info -->
      <div class="announcement-info">
        <h1 class="vacant-position-header">
          {{ 'label.InformationAboutTheVacantPosition' | translate }}
        </h1>
        <div
          class="announcement-details categories-details-container"
          [class.changed-label]="
            isChanged(entityAttributes.AnnouncementRequirementSpecialization)
          "
        >
          <span style="font-weight: 600"
            >{{ 'label.SpecialitySpecialization' | translate }}:
          </span>

          <div class="specialization-list">
            @for (specialization of announcement.announcementRequirements
            ?.specializationList; track $index) {
            <div style="margin-bottom: 5px">
              <span class="specialization-position-main"
                >{{ specialization.name }} ></span
              >
              @if (specialization.children?.length) {
              <div>
                @for (childCategory of specialization.children; track $index; let
                last = $last) {
                <span>{{
                  last ? childCategory.name + '.' : childCategory.name + ', '
                }}</span>
                }
              </div>
              }
            </div>
            }
          </div>
        </div>

        <!-- industries row container -->
        <div
          class="announcement-details industries-details-container"
          [class.changed-label]="
            isChanged(entityAttributes.AnnouncementRequirementIndustry)
          "
        >
          <span style="font-weight: 600"
            >{{ 'label.IndustryField' | translate }}:
          </span>

          <div class="industry-list">
            @for (industry of announcement.announcementRequirements
            ?.industryList; track $index) {
            <div style="margin-bottom: 5px">
              <span class="industry-position-main">
                {{ industry.name }} >
              </span>

              @if (industry.children?.length) {
              <div style="display: inline; padding-left: 5px">
                @for (childIndustry of industry.children; track $index; let last
                = $last) {
                <span>
                  {{
                    last ? childIndustry.name + '.' : childIndustry.name + ', '
                  }}
                </span>
                }
              </div>
              }
            </div>
            }
          </div>
        </div>

        <div
          class="announcement-details"
          [class.changed-label]="isChanged(entityAttributes.EmploymentType)"
        >
          <span style="font-weight: 600"
            >{{ 'label.EmploymentForm' | translate }}:
          </span>
          <span>{{
            announcement.announcementRequirements?.employmentTypeName
          }}</span>
        </div>
        <div
          class="announcement-details"
          [class.changed-label]="isChanged(entityAttributes.WorkSchedule)"
        >
          <span style="font-weight: 600"
            >{{ 'label.Schedule' | translate }}:
          </span>
          <span>{{
            announcement.announcementRequirements?.workScheduleName
          }}</span>
        </div>
        <div
          class="announcement-details"
          [class.changed-label]="
            isChanged(entityAttributes.AnnouncementRequirementSeniorityLevel)
          "
        >
          <span style="font-weight: 600"
            >{{ 'label.SeniorityLevel' | translate }}:
          </span>
          <span
            *ngFor="
              let seniorityLevel of announcement.announcementRequirements
                ?.seniorityLevels;
              let last = last
            "
            >{{ last ? seniorityLevel : seniorityLevel + ', ' }}</span
          >
        </div>
        <div
          class="announcement-details"
          [class.changed-label]="isChanged(entityAttributes.EmploymentForm)"
        >
          <span style="font-weight: 600"
            >{{ 'label.WorkLocation' | translate }}:
          </span>
          <span>{{ announcement.employmentFormTypeName }}</span>
        </div>
        <div
          class="announcement-details"
          [class.changed-label]="isChanged(entityAttributes.IsWorkFromHome)"
        >
          <span style="font-weight: 600"
            >{{ 'label.WorkFromHome' | translate }}:
          </span>
          <span>{{
            announcement.isWorkFromHome
              ? ('label.Yes' | translate)
              : ('label.No' | translate)
          }}</span>
        </div>
        <div
          class="announcement-details"
          [class.changed-label]="
            isAnyChanged(
              entityAttributes.IsTravelRequired,
              entityAttributes.IsTravelDomestic,
              entityAttributes.IsTravelAbroad,
              entityAttributes.TravelPercentage
            )
          "
        >
          <span style="font-weight: 600"
            >{{ 'label.PositionRequiresFrequentTravel' | translate }}:
          </span>
          <span>{{ travelRequirementsText }}</span>
        </div>
        <div
          class="announcement-details"
          [class.changed-label]="isChanged(entityAttributes.ExtendedLocations)"
        >
          <span style="font-weight: 600"
            >{{ 'label.Location' | translate }}:
          </span>
          <div *ngFor="let location of announcement.extendedLocations">
            <span
              *ngFor="
                let extendedLocations of location.announcementExtendedLocationParts;
                let last = last
              "
              >{{ extendedLocations.name + (last ? '.' : ',') }}
            </span>
          </div>
        </div>
        <div
          class="announcement-details"
          [class.changed-label]="isChanged(entityAttributes.Benefit)"
        >
          <span style="font-weight: 600"
            >{{ 'label.Benefits' | translate }}:
          </span>

          <span *ngFor="let benefit of announcement.benefits; let last = last"
            >{{
              benefit
                ? benefit + (last ? '.' : ',')
                : ('label.NotSelected' | translate)
            }}
          </span>
        </div>
        <div
          class="announcement-details"
          [class.changed-label]="
            isAnyChanged(
              entityAttributes.SalaryFrom,
              entityAttributes.SalaryTo,
              entityAttributes.BonusFrom,
              entityAttributes.BonusTo
            )
          "
        >
          <span style="font-weight: 600"
            >{{ 'label.Salary' | translate }}:
          </span>
          <span *ngIf="announcement.salaryFrom && announcement.salaryTo"
            >{{ announcement.salaryFrom }} - {{ announcement.salaryTo }}</span
          >
          <span *ngIf="announcement.salaryFrom && !announcement.salaryTo">{{
            announcement.salaryFrom
          }}</span>
          <span *ngIf="!announcement.salaryFrom && announcement.salaryTo">{{
            announcement.salaryTo
          }}</span>
          <span *ngIf="!announcement.salaryFrom && !announcement.salaryTo">{{
            'label.NotSelected' | translate
          }}</span>
          <span *ngIf="announcement.isWithBonus">
            + {{ 'label.Bonus' | translate }}
            {{
              announcement.bonusFrom && announcement.bonusTo
                ? announcement.bonusFrom + ' - ' + announcement.bonusTo
                : announcement.bonusTo
                ? announcement.bonusTo
                : announcement.bonusFrom
                ? announcement.bonusFrom
                : ''
            }}</span
          >
        </div>
        <div
          class="announcement-details"
          [class.changed-label]="isChanged(entityAttributes.Attachment)"
          *ngIf="announcement.attachmentFileName"
        >
          <a [href]="announcement.attachmentFileName" class="attachment">
            <svg-icon src="assets/img/attachment.svg"></svg-icon>
            <span style="font-weight: 500; color: #819dcd"
              >{{ 'label.Attachment' | translate }}
            </span>
          </a>
        </div>
      </div>

      <!-- description -->
      <div class="announcement-description">
        <div class="description-header">
          <h1 [class.changed-label]="isChanged(entityAttributes.Description)">
            {{ 'label.Description' | translate }}
          </h1>
        </div>
        <div
          class="description"
          [innerHTML]="
            isEdited
              ? (editedDescription | safeHtml)
              : (announcement.description | safeHtml)
          "
        ></div>
      </div>
      <div class="announcement-description" *ngIf="announcement.title2">
        <div class="description-header">
          <h1 [class.changed-label]="isChanged(entityAttributes.Description2)">
            {{ 'label.Description' | translate }} {{ alternativeLanguage }}
          </h1>
        </div>
        <div
          class="description"
          [innerHTML]="
            isEdited
              ? (editedDescription2 | safeHtml)
              : (announcement.description2 | safeHtml)
          "
        ></div>
      </div>

      <div class="products-and-feedbacks">
        <div class="announcement-logos">
          <div class="main-logo">
            <span
              [class.changed-label]="isChanged(entityAttributes.Logo_Main)"
              style="font-weight: 600"
              >{{ 'label.MainLogo' | translate }}
            </span>
            <img
              [src]="
                announcement.logoFileName
                  ? announcement.logoFileName
                  : 'assets/img/without_logo.jpg'
              "
              alt=""
            />
          </div>
          <div class="list-logo">
            <span
              [class.changed-label]="isChanged(entityAttributes.Logo_Thumbnail1)"
              style="font-weight: 600"
              >{{ 'label.LogoForList' | translate }}
            </span>
            <img
              [src]="
                announcement.logoThumbnailFileName
                  ? announcement.logoThumbnailFileName
                  : 'assets/img/without_logo.jpg'
              "
              alt=""
            />
          </div>
        </div>

        <!-- requirement -->
        <div class="requirements">
          <h1>{{ 'label.EmploymentRequirements' | translate }}</h1>
          <div
            class="requirement"
            [class.changed-label]="
              isAnyChanged(
                entityAttributes.IsWorkExperienceYearsMandatory,
                entityAttributes.WorkExperienceFrom,
                entityAttributes.WorkExperienceTo,
                entityAttributes.WorkExperienceType
              )
            "
          >
            <span style="font-weight: 600"
              >{{ 'label.YearsOfWorkExperience' | translate }}:
            </span>
            <span
              *ngIf="
                announcement.workExperienceTypeId !==
                workExperienceTypeEnum.ExperienceNeeded
              "
              >{{
                announcement.workExperienceTypeName ||
                  ('label.NotSelected' | translate)
              }}</span
            >
            <span
              *ngIf="
                announcement.workExperienceTypeId ===
                workExperienceTypeEnum.ExperienceNeeded
              "
            >
              {{
                ((announcement?.employerRequirements
                  ?.isWorkExperienceYearsMandatory
                  ? 'label.MandatoryExperience'
                  : 'label.DesiredExperience'
                ) | translate) + ' '
              }}
            </span>
            <span
              *ngIf="
                announcement.workExperienceFrom && announcement.workExperienceTo
              "
              >{{ announcement.workExperienceFrom }} -
              {{ announcement.workExperienceTo }}</span
            >
            <span
              *ngIf="
                announcement.workExperienceFrom &&
                !announcement.workExperienceTo
              "
              >{{ announcement.workExperienceFrom }}
              {{ 'label.From' | translate }}</span
            >
            <span
              *ngIf="
                !announcement.workExperienceFrom &&
                announcement.workExperienceTo
              "
              >{{ announcement.workExperienceTo }}
              {{ 'label.To' | translate }}</span
            >
          </div>

          <div
            class="requirement categories-details-container"
            [class.changed-label]="
              isAnyChanged(
                entityAttributes.EmploymentRequirementSpecialization,
                entityAttributes.IsSpecializationMandatory
              )
            "
          >
            <span style="font-weight: 600"
              >{{
                ('label.SpecialitySpecialization' | translate) +
                  '(' +
                  (announcement.employerRequirements?.isSpecializationMandatory
                    ? ('label.Mandatory' | translate)
                    : ('label.Desired' | translate)) +
                  ')'
              }}:
            </span>
            <div class="specialization-list">
              @for (specialization of announcement.employerRequirements
              ?.specializationList; track $index) {
              <div
                style="margin-bottom: 5px"
                class="specialization-requirement-container"
              >
                <span class="specialization-position-main"
                  >{{ specialization.name }} ></span
                >
                @if (specialization.children?.length) {
                <div>
                  @for (childCategory of specialization.children; track $index;
                  let last = $last) {
                  <span>{{
                    last ? childCategory.name + '.' : childCategory.name + ', '
                  }}</span>
                  }
                </div>
                }
              </div>
              }
            </div>
          </div>

          <div
            class="requirement industries-details-container"
            [class.changed-label]="
              isAnyChanged(
                entityAttributes.EmploymentRequirementIndustry,
                entityAttributes.IsIndustryMandatory
              )
            "
          >
            <span style="font-weight: 600"
              >{{
                ('label.IndustryField' | translate) +
                  '(' +
                  (announcement.employerRequirements?.isIndustryMandatory
                    ? ('label.Mandatory' | translate)
                    : ('label.Desired' | translate)) +
                  ')'
              }}:
            </span>

            <div class="industry-list">
              @for (industry of announcement.employerRequirements?.industryList;
              track $index) {
              <div style="margin-bottom: 5px">
                <span class="specialization-position-main"
                  >{{ industry.name }} ></span
                >
                @if (industry.children?.length) {
                <div>
                  @for (childIndustry of industry.children; track $index; let
                  last = $last) {
                  <span>{{
                    last ? childIndustry.name + '.' : childIndustry.name + ', '
                  }}</span>
                  }
                </div>
                }
              </div>
              }
            </div>
          </div>

          <div
            class="requirement"
            [class.changed-label]="
              isChanged(entityAttributes.EmployerRequirementSeniorityLevel)
            "
          >
            <span style="font-weight: 600"
              >{{ 'label.SeniorityLevel' | translate }}:
            </span>
            <span
              *ngFor="
                let seniorityLevelName of announcement.employerRequirements
                  ?.seniorityLevels;
                let last = last
              "
              >{{ last ? seniorityLevelName : seniorityLevelName + ', ' }}</span
            >
          </div>

          <div
            class="requirement"
            [class.changed-label]="isChanged(entityAttributes.EducationLevel)"
          >
            <span style="font-weight: 600"
              >{{ 'label.MinimumEducationLevel' | translate }}:
            </span>
            @if (announcement.employerRequirements?.educationLevels?.length) {
            <span>
              @for (educationLevel of announcement.employerRequirements
              .educationLevels; track $index; let last = $last) {
              <span>{{ last ? educationLevel : educationLevel + ', ' }}</span>
              }
            </span>
            } @else {
            <span> {{ 'label.NotSelected' | translate }}</span>
            }
          </div>

          <div
            class="requirement"
            [class.changed-label]="isChanged(entityAttributes.EducationProgram)"
          >
            <span style="font-weight: 600"
              >{{ 'label.EducationalProgram' | translate }}:
            </span>
            @if (announcement.employerRequirements?.educationPrograms?.length) {
            <span>
              @for (educationProgram of announcement.employerRequirements
              .educationPrograms; track $index; let last = $last) {
              <span>{{
                last ? educationProgram : educationProgram + ', '
              }}</span>
              }
            </span>
            } @else {
            <span> {{ 'label.NotSelected' | translate }}</span>
            }
          </div>

          <div
            class="requirement"
            [class.changed-label]="
              isChanged(entityAttributes.IsSuitableForStudent)
            "
          >
            <span style="font-weight: 600"
              >{{ 'label.SuitableForStudents' | translate }}:
            </span>
            <span>{{
              announcement.isSutableForStudent
                ? ('label.Yes' | translate)
                : ('label.No' | translate)
            }}</span>
          </div>

          <div
            class="requirement skill-requirement"
            [class.changed-label]="isChanged(entityAttributes.HardSkills)"
          >
            <span style="font-weight: 600"
              >{{ 'label.HardSkills' | translate }}:
            </span>
            <div class="skill-chips">
              @for (skill of hardSkills; track skill.index) {
              <div
                class="skill-chip"
                [ngClass]="{ 'skill-chip--custom': isCustom(skill) }"
              >
                @if (isAdded(skill, hardSkillChanges) && isEdited) {
                <span class="skill-chip__new-badge">{{
                  'label.NewBadge' | translate
                }}</span>
                }
                <span class="skill-chip__name">{{ skillName(skill) }}</span>
              </div>
              } @if (isEdited) { @for (skill of removedHardSkills; track
              skill.index) {
              <div class="skill-chip skill-chip--removed">
                <span class="skill-chip__name">{{
                  removedSkillName(skill)
                }}</span>
              </div>
              } } @if (showHardSkillsPlaceholder) {
              <div class="skill-chip skill-chip--placeholder"></div>
              <div class="skill-chip skill-chip--placeholder"></div>
              <div class="skill-chip skill-chip--placeholder"></div>
              }
            </div>
          </div>

          <div
            class="requirement skill-requirement soft-skill-requirement"
            [class.changed-label]="isChanged(entityAttributes.SoftSkills)"
          >
            <span style="font-weight: 600"
              >{{ 'label.SoftSkills' | translate }}:
            </span>
            <div class="skill-chips">
              @for (skill of softSkills; track skill.index) {
              <div
                class="skill-chip"
                [ngClass]="{ 'skill-chip--custom': isCustom(skill) }"
              >
                @if (isAdded(skill, softSkillChanges) && isEdited) {
                <span class="skill-chip__new-badge">{{
                  'label.NewBadge' | translate
                }}</span>
                }
                <span class="skill-chip__name">{{ skillName(skill) }}</span>
              </div>
              } @if (isEdited) { @for (skill of removedSoftSkills; track
              skill.index) {
              <div class="skill-chip skill-chip--removed">
                <span class="skill-chip__name">{{
                  removedSkillName(skill)
                }}</span>
              </div>
              } } @if (showSoftSkillsPlaceholder) {
              <div class="skill-chip skill-chip--placeholder"></div>
              <div class="skill-chip skill-chip--placeholder"></div>
              <div class="skill-chip skill-chip--placeholder"></div>
              }
            </div>
          </div>

          <div
            class="requirement"
            [class.changed-label]="isChanged(entityAttributes.RequiredLanguage)"
          >
            <span style="font-weight: 600"
              >{{ 'label.Languages' | translate }}:
            </span>
            <span
              *ngIf="
                announcement.requiredLanguages?.length &&
                  announcement.requiredLanguages.length > 0;
                else notSelected
              "
            >
              <span
                *ngFor="
                  let language of announcement.requiredLanguages;
                  let last = last
                "
              >
                {{
                  isMandatory(language.name, language.isMandatory) +
                    (last ? '.' : ',')
                }}
              </span></span
            >
          </div>
          <div
            class="requirement"
            [class.changed-label]="isChanged(entityAttributes.DrivingLicence)"
          >
            <span style="font-weight: 600"
              >{{ 'label.DrivingLicence' | translate }}:
            </span>
            <span
              >{{
                drivingLicences.length
                  ? ('label.Yes' | translate)
                  : ('label.No' | translate)
              }}
            </span>
            @if (drivingLicences.length) {
            <span>({{ drivingLicences.join(', ') }}) </span>
            }
          </div>
          <div
            class="requirement"
            [class.changed-label]="isChanged(entityAttributes.HasTransport)"
          >
            <span style="font-weight: 600"
              >{{ 'label.OwnTransport' | translate }}:
            </span>
            <span>{{
              announcement.employerRequirements?.hasTransport
                ? ('label.Yes' | translate)
                : ('label.No' | translate)
            }}</span>
          </div>
          <div
            class="requirement"
            [class.changed-label]="isChanged(entityAttributes.TransportType)"
          >
            <span style="font-weight: 600"
              >{{ 'label.TransportType' | translate }}:
            </span>
            <span
              *ngIf="
                announcement.employerRequirements?.transportTypes?.length &&
                  announcement.employerRequirements?.transportTypes?.length > 0;
                else notSelected
              "
            >
              <span
                *ngFor="
                  let transport of announcement.employerRequirements
                    ?.transportTypes;
                  let last = last
                "
              >
                {{ transport + (last ? '.' : ',') }}
              </span></span
            >
          </div>
        </div>

        <!-- feedback -->
        <div class="feedbacks">
          <h1>{{ 'label.Apply' | translate }}</h1>
          <div
            class="feedback"
            [class.changed-label]="isChanged(entityAttributes.ContactPerson)"
          >
            <span style="font-weight: 600"
              >{{ 'label.ContactPerson' | translate }}:
            </span>
            <span>{{
              announcement.contactName + ' ' + announcement.contactSurname
            }}</span>
          </div>
          <div
            class="feedback"
            [class.changed-label]="isChanged(entityAttributes.ApplicationMethod)"
          >
            <span style="font-weight: 600"
              >{{ 'label.ApplicationRule' | translate }}:
            </span>
            <span>{{ announcement.applicationMethodName }}</span>
          </div>
          <div
            class="feedback"
            *ngIf="
              announcement.applicationMethodId === applicationRuleEnum.ViaLink
            "
          >
            <span *ngIf="announcement.applicationDetail?.applicationUrl"
              ><span style="font-weight: 600"
                >{{ 'label.Website' | translate }}:</span
              >
              {{ announcement.applicationDetail.applicationUrl }}</span
            >
          </div>
          <div
            class="feedback application-rule"
            *ngIf="
              announcement.applicationMethodId ===
              applicationRuleEnum.MobilePostAddress
            "
          >
            <span *ngIf="announcement.applicationDetail?.phoneNumber"
              ><span style="font-weight: 600"
                >{{ 'label.MobileNumber' | translate }}:</span
              >
              {{ announcement.applicationDetail.phoneNumber }}</span
            >
            <span *ngIf="announcement.applicationDetail?.email"
              ><span style="font-weight: 600"
                >{{ 'label.ApplicationEmail' | translate }}:</span
              >
              {{ announcement.applicationDetail.email }}</span
            >
            <span *ngIf="announcement.applicationDetail?.applicationAddress"
              ><span style="font-weight: 600"
                >{{ 'label.Address' | translate }}:</span
              >
              {{ announcement.applicationDetail.applicationAddress }}</span
            >
          </div>
          <div
            class="feedback"
            [class.changed-label]="
              isAnyChanged(
                entityAttributes.PublishDate,
                entityAttributes.DeadlineDate
              )
            "
          >
            <span style="font-weight: 600"
              >{{ 'label.Dates' | translate }}:
            </span>
            <span
              >{{ 'label.Placement' | translate }} -
              {{ announcement.publishDate | date: 'yyyy-MM-dd' }},
              {{ 'label.Deadline' | translate }} -
              {{ announcement.deadlineDate | date: 'yyyy-MM-dd' }}</span
            >
          </div>
        </div>

        <!-- product -->
        <div class="products">
          <h1>{{ 'label.Products' | translate }}</h1>
          <ul class="product" *ngFor="let product of products">
            <li class="product-item">
              {{ product.name }} -
              <span
                >{{ product.price }}
                <svg
                  width="11"
                  height="13"
                  viewBox="0 0 11 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.1213 12.074L9.20225 13H0L0.915148 12.0786H2.47337C2.47337 12.0786 1.10651 11.2385 0.471894 9.71494C-0.162722 8.19135 -0.292899 6.01245 1.05769 4.17759C2.40828 2.34273 3.93787 2.09699 3.93787 2.09699V0.933814L4.84911 0.0163827V1.90039C4.84911 1.90039 5.87426 1.76933 6.23225 1.91678V0.901048L7.12722 0V2.09699C7.89282 2.3266 8.59852 2.72381 9.19379 3.26016C9.19379 3.26016 10.6257 4.24312 11 6.58585L10.1786 7.4135C10.1786 7.4135 10.105 6.63499 10.0399 6.30734C9.97485 5.97969 9.37278 4.53801 8.60799 3.94823C7.8432 3.35845 7.35503 3.07995 7.12722 3.06356V6.50393L6.23225 7.40498V2.81782C6.23225 2.81782 5.32101 2.63761 4.84911 2.83421V6.49345L3.91639 7.4325V3.06356C3.91639 3.06356 2.24556 3.70249 1.52959 5.09502C0.81361 6.48755 0.553254 8.66645 1.78994 10.1573C3.02663 11.6481 4.23077 12.074 6.24852 12.074H10.1213Z"
                    fill="#495678"
                  />
                  <path
                    d="M10.1213 12.074L9.20225 13H0L0.915148 12.0786H2.47337C2.47337 12.0786 1.10651 11.2385 0.471894 9.71494C-0.162722 8.19135 -0.292899 6.01245 1.05769 4.17759C2.40828 2.34273 3.93787 2.09699 3.93787 2.09699V0.933814L4.84911 0.0163827V1.90039C4.84911 1.90039 5.87426 1.76933 6.23225 1.91678V0.901048L7.12722 0V2.09699C7.89282 2.3266 8.59852 2.72381 9.19379 3.26016C9.19379 3.26016 10.6257 4.24312 11 6.58585L10.1786 7.4135C10.1786 7.4135 10.105 6.63499 10.0399 6.30734C9.97485 5.97969 9.37278 4.53801 8.60799 3.94823C7.8432 3.35845 7.35503 3.07995 7.12722 3.06356V6.50393L6.23225 7.40498V2.81782C6.23225 2.81782 5.32101 2.63761 4.84911 2.83421V6.49345L3.91639 7.4325V3.06356C3.91639 3.06356 2.24556 3.70249 1.52959 5.09502C0.81361 6.48755 0.553254 8.66645 1.78994 10.1573C3.02663 11.6481 4.23077 12.074 6.24852 12.074H10.1213Z"
                    stroke="#495678"
                  />
                </svg>
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div
        class="buttons"
        *ngIf="(isCreate && !isEdited) || (!isCreate && isEdited)"
      >
        <div class="buttons-head">
          <div class="company-profile">
            <div
              (click)="onLoginAsCustomer(announcement?.customerId)"
              class="customer-login"
            >
              <svg-icon
                src="assets/img/go_to_company_profile.svg"
                [svgStyle]="{ 'height.px': 25, 'width.px': 25 }"
              ></svg-icon
              ><span>{{ 'label.GoToCompanyProfile' | translate }}</span>
            </div>
          </div>
          <div class="button-container">
            <button
              class="approve"
              (click)="onApprove(announcementModerationId)"
            >
              {{ 'label.ConfirmChanges' | translate }}
            </button>
            <button class="reject" (click)="onReject(announcementModerationId)">
              {{ 'label.Reject' | translate }}
            </button>
          </div>
        </div>
        <div class="refresh-page">
          <button (click)="refreshPage()">
            <svg-icon
              src="assets/img/refresh_page.svg"
              [svgStyle]="{ 'height.px': 25, 'width.px': 25 }"
            ></svg-icon
            ><span>{{ 'label.RenewAnnouncement' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <ng-template #notSelected>
    <span>{{ 'label.NotSelected' | translate }}</span>
  </ng-template>
</ng-container>
